import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

import { ref, toRefs, Ref, onMounted, watch, nextTick } from 'vue';

interface Props {
  value: string,
  focus: boolean,
  shouldAutoFocus: boolean,
  inputType: 'number' | 'tel' | 'password'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleDigitInputComponent',
  props: {
    value: { default: '' },
    focus: { type: Boolean, default: false },
    shouldAutoFocus: { type: Boolean, default: false },
    inputType: { default: 'tel' }
  },
  emits: [
  'on-change',
  'on-keydown',
  'on-paste',
  'on-focus',
  'on-blur'
],
  setup(__props: any, { emit }) {

const props = __props as { value: string, focus: boolean, shouldAutoFocus: boolean, inputType: 'number' | 'tel' | 'password' }



const {
  value,
  focus,
  shouldAutoFocus,
  inputType,
} = toRefs(props);



const input: Ref<HTMLInputElement | null> = ref(null);
const model: Ref<String> = ref('');

function handleOnChange() {
  model.value = String(model.value).slice(0, 1);
    
  return emit('on-change', model.value);
}

function  handleOnKeyDown(event: KeyboardEvent) {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (isCodeNumeric(charCode)
      || (charCode === 8) // Backspace
      || (charCode === 37) // ArrowLeft
      || (charCode === 39) // ArrowRight
      || (charCode === 13) // Enter
      || (charCode === 86) // KeyV(Paste)
      || (charCode === 46)) { // Delete
    emit('on-keydown', event);
  } else {
    event.preventDefault();
  }
}

function isCodeNumeric(charCode: number) {
  return (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105);
}

function handleOnPaste(event: ClipboardEvent) {
  return emit('on-paste', event);
}

function handleOnFocus() {
  if (input.value) input.value.select();
  return emit('on-focus');
}

function handleOnBlur() {
  return emit('on-blur');
}

onMounted(() => {
  if (input.value && focus.value && shouldAutoFocus.value) {
    nextTick(() => {
      input.value.focus();
      input.value.select();
    })
  }
})

watch(value, (newValue: string, oldValue: string) => {
  if (newValue !== oldValue) model.value = newValue;
});

watch(focus, (newFocusValue: boolean, oldFocusValue: boolean) => {
  if (oldFocusValue !== newFocusValue && (input.value && focus.value)) {
    input.value.focus();
    input.value.select();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "input",
      ref: input,
      class: "single-digit-input medium black",
      type: _unref(inputType),
      min: "0",
      max: "9",
      maxlength: "1",
      pattern: "[0-9]",
      inputmode: "decimal",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      placeholder: "X",
      autocomplete: "one-time-code",
      onInput: handleOnChange,
      onKeydown: handleOnKeyDown,
      onPaste: handleOnPaste,
      onFocus: handleOnFocus,
      onBlur: handleOnBlur
    }, null, 40, _hoisted_1), [
      [_vModelDynamic, model.value]
    ])
  ]))
}
}

})